/**
 * FilePreviewRenderer - File preview DOM generation
 * Images, PDF, Word icons before/after upload
 */

/**
 * Create a single file preview element
 */
function createPreviewItem(entry, index, onRemove) {
  const previewItem = document.createElement('div')
  previewItem.className = 'position-relative d-inline-block border rounded p-1'
  previewItem.style.width = '60px'
  previewItem.style.height = '60px'

  const closeBtn = document.createElement('button')
  closeBtn.className = 'btn btn-sm btn-danger position-absolute top-0 start-100 translate-middle rounded-circle p-0 d-flex align-items-center justify-content-center'
  closeBtn.style.width = '20px'
  closeBtn.style.height = '20px'
  closeBtn.innerHTML = '&times;'
  closeBtn.dataset.index = index
  closeBtn.dataset.action = `click->${onRemove}`
  previewItem.appendChild(closeBtn)

  const contentType = entry.contentType || (entry.file && entry.file.type)

  if (entry.status === 'error') {
    previewItem.appendChild(createErrorContent())
  } else if (entry.previewUrl || (contentType && contentType.startsWith('image/'))) {
    previewItem.appendChild(createImageContent(entry))
    if (entry.status === 'uploading') previewItem.style.opacity = '0.7'
  } else if (contentType === 'application/pdf') {
    previewItem.appendChild(createIconContent('file-pdf', 'text-danger', entry.status))
  } else if (isWordType(contentType)) {
    previewItem.appendChild(createIconContent('file-word', 'text-primary', entry.status))
  } else {
    previewItem.appendChild(createIconContent('file-earmark', 'text-secondary', entry.status))
  }

  return previewItem
}

function createErrorContent() {
  const div = document.createElement('div')
  div.className = 'w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-danger bg-opacity-25 rounded small text-danger'
  div.innerHTML = "<i class='bi bi-exclamation-triangle'></i><span>Error</span>"
  return div
}

function createImageContent(entry) {
  const img = document.createElement('img')
  img.src = entry.previewUrl || (entry.file && URL.createObjectURL(entry.file))
  img.className = 'w-100 h-100 object-fit-cover rounded'
  return img
}

function createIconContent(iconClass, colorClass, status) {
  const icon = document.createElement('div')
  icon.className = `w-100 h-100 d-flex align-items-center justify-content-center bg-light rounded ${colorClass}`
  const iconName = status === 'uploading' ? 'hourglass-split' : iconClass
  icon.innerHTML = `<i class='bi bi-${iconName} fs-4'></i>`
  return icon
}

function isWordType(contentType) {
  return contentType === 'application/msword' ||
    contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

/**
 * Update the file preview container with selected files
 */
export function renderFilePreview(containerElement, fileUploadAreaElement, selectedFiles, removeAction = 'ai#removeFile') {
  containerElement.innerHTML = ''

  if (!selectedFiles?.length) {
    fileUploadAreaElement.style.display = 'none'
    return
  }

  fileUploadAreaElement.style.display = 'block'

  selectedFiles.forEach((entry, index) => {
    const item = createPreviewItem(entry, index, removeAction)
    containerElement.appendChild(item)
  })
}
